import React from "react";
import "../styles/StatCard.css"; // ✅ Keep styles in StatCard.css

const StatCard = () => {
  return (
    <div className="image-card">
      <img src="/office.jpg" alt="Office Work" className="office-image" />
    </div>
  );
};

export default StatCard;
